const accountTypes = {
  GET_ACCESS_TOKEN: "GET ACCESS TOKEN",
  GET_ACCOUNT: "GET BANK ACCOUNTS",
};

export default accountTypes;
